import Block from 'actions/block';

export default Block.createReducer();